import React from "react";
import PropTypes from "prop-types";
import Button from "lib/common/descriptorcontrols/BaseControls/Button";
import Dispatcher from "Dispatcher";
import MergeActions from "data/MergeActions";
import TableStore from "data/TableStore";
import NavigatorStore from "data/NavigatorStore";
import { getTableKeys } from "data/selectors/stereotypes";
import { MERGE_PLUGINS, MERGE_CONTEXT } from "data/MergeStore";
import useFluxStore from "@armus/use-flux-store";
import StereotypesStore from "data/StereotypesStore";

export class GlobalMergeButtonView extends React.Component {
    render() {
        const {
            items = [],
            label,
            onClick
        } = this.props;
        if(!onClick || items.length === 0) {
            return null;
        }
        return (
            <Button
                label={label}
                enabled={items.length !== 0}
                className={"btn btn-small btn-secondary btn-merge mergeRoot btn-dark"}
                options={items}
                onClick={(e, d, item) => onClick && onClick(e, item)}
                collapse={true}
            />
        );
    }
}

GlobalMergeButtonView.propTypes = {
    label: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired
    })),
    onClick: PropTypes.func,
};

const GlobalMergeButton = props => {
    const {fluxContext, onClick} = props;
    const state = useFluxStore(() => {
        if (!fluxContext) return null;
        const magicState = NavigatorStore.getMagicState(fluxContext);
        if (!magicState) return null;
        const stereoInfo = StereotypesStore.getStereotypeByKey(magicState.key);

        const backedTables = getTableKeys(stereoInfo);

        // If there is more then one table backing the sp then we should not allow
        // merging until we can guarantee that the two tables are indeed compatible.
        if(backedTables.length > 1) {
            return null;
        }

        const targetRecord = TableStore.getStereotypeProxy(magicState.key, magicState.id);
        // global merge plugins ... if we add more do it here.
        const items = [
            {
                label: `Merge to ${targetRecord.getLabel()}`,
                value: MERGE_PLUGINS.GLOBAL_MERGE,
                _record: {
                    stereoKey: magicState.key,
                    id: magicState.id,
                },
            },
        ];
        const label = `Merge ${stereoInfo.name}`;
        return {
            items: items,
            label: label,
            onClick: (e, item) => {
                // initialize the merge store for interactive modal.
                Dispatcher.contextDispatch(fluxContext + MERGE_CONTEXT, {
                    type: MergeActions.LAUNCH_DIALOG,
                    title: item.label,
                    plugin: item.value,
                    target: item._record,
                });
            }
        };
    }, [
        TableStore,
        NavigatorStore
    ], [fluxContext, onClick]);
    return state == null
        ? null
        : <GlobalMergeButtonView {...props} {...state} />;
};

GlobalMergeButton.propTypes = {
    fluxContext: PropTypes.string,
    onClick: PropTypes.func
};

export default GlobalMergeButton;



// WEBPACK FOOTER //
// ./app/lib/merge/mergebutton/GlobalMergeButton.js